import React, { createContext, useContext, useState } from 'react';

export interface MappingSidebarColumnState {
  columnVisibilityModel: Record<string, boolean>;
  setColumnVisibilityModel: (updater: (prev: Record<string, boolean>) => Record<string, boolean>) => void;
  columnOrder: string[] | undefined;
  setColumnOrder: (order: string[]) => void;
  /** True when the active mapping panel is evidence (including evidence-only mappings). */
  isEvidence: boolean;
  columnPanelToggle?: { active: 'summary' | 'evidence'; onChange: (active: 'summary' | 'evidence') => void };
}

interface MappingSidebarColumnContextValue {
  state: MappingSidebarColumnState | null;
  setState: (s: MappingSidebarColumnState | null) => void;
}

const defaultValue: MappingSidebarColumnContextValue = {
  state: null,
  setState: () => {},
};

export const MappingSidebarColumnContext = createContext<MappingSidebarColumnContextValue>(defaultValue);

export function useMappingSidebarColumn(): MappingSidebarColumnContextValue {
  return useContext(MappingSidebarColumnContext);
}

export function MappingSidebarColumnProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<MappingSidebarColumnState | null>(null);
  const value = React.useMemo(() => ({ state, setState }), [state]);
  return (
    <MappingSidebarColumnContext.Provider value={value}>{children}</MappingSidebarColumnContext.Provider>
  );
}
